// Simple connection test utility
import { projectId, publicAnonKey } from './supabase/info.tsx';
import { EDGE_FUNCTIONS_BASE } from './edge';

export async function testServerConnection() {
  const baseUrl = `${EDGE_FUNCTIONS_BASE}/adcanvas-health`;
  
  console.log('🔍 Testing server connection...');
  console.log('Project ID:', projectId);
  console.log('Base URL:', baseUrl);
  
  try {
    // Test health endpoint
    console.log('1. Testing health endpoint...');
    const healthResponse = await fetch(`${baseUrl}/health`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${publicAnonKey}`,
        'Content-Type': 'application/json',
      },
      // Add timeout to prevent hanging
      ...(typeof AbortSignal !== 'undefined' && AbortSignal.timeout ? 
        { signal: AbortSignal.timeout(10000) } : {})
    });
    
    console.log('Health response status:', healthResponse.status);
    
    if (healthResponse.ok) {
      const healthData = await healthResponse.json();
      console.log('✅ Health check passed:', healthData);
      return { success: true, health: healthData };
    } else {
      const healthError = await healthResponse.text();
      console.log('❌ Health check failed:', healthError);
      return { success: false, healthError };
    }
    
  } catch (error) {
    console.error('❌ Connection test error:', error);
    return { success: false, error: error.message };
  }
}